import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["className", "status", "disabled", "label", "labelMode", "showSearch", "searchValue", "onSearch", "dropdownRender", "size", "placeholder", "onChange", "onFocus", "onBlur", "style", "errors", "ErrorNode", "warnings", "bordered", "onDropdownVisibleChange", "maxTagCount", "maxTagPlaceholder"];
import { IconSearch16pxRegular } from "@pionex-web-kit/icons";
import { default as classNames, default as cns } from "classnames";
import React, { forwardRef, useCallback, useEffect, useRef, useState } from "react";
import { getPrefixCls } from "../config";
import useEvent from "../hack/rc-util/hooks/useEvent";
import useMergedState from "../hack/rc-util/hooks/useMergedState";
import Input from "../Input";
import ASelect from "./hack/Select";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var Select = /*#__PURE__*/forwardRef(function Select(_ref, ref) {
  var _cns;
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? "" : _ref$className,
    status = _ref.status,
    disabled = _ref.disabled,
    label = _ref.label,
    _ref$labelMode = _ref.labelMode,
    labelMode = _ref$labelMode === void 0 ? "top" : _ref$labelMode,
    showSearch = _ref.showSearch,
    pSearchValue = _ref.searchValue,
    onSearch = _ref.onSearch,
    dropdownRender = _ref.dropdownRender,
    size = _ref.size,
    placeholder = _ref.placeholder,
    onChange = _ref.onChange,
    onFocus = _ref.onFocus,
    onBlur = _ref.onBlur,
    style = _ref.style,
    errors = _ref.errors,
    ErrorNode = _ref.ErrorNode,
    warnings = _ref.warnings,
    _ref$bordered = _ref.bordered,
    bordered = _ref$bordered === void 0 ? true : _ref$bordered,
    onDropdownVisibleChange = _ref.onDropdownVisibleChange,
    _ref$maxTagCount = _ref.maxTagCount,
    maxTagCount = _ref$maxTagCount === void 0 ? "responsive" : _ref$maxTagCount,
    _ref$maxTagPlaceholde = _ref.maxTagPlaceholder,
    maxTagPlaceholder = _ref$maxTagPlaceholde === void 0 ? "..." : _ref$maxTagPlaceholde,
    props = _objectWithoutProperties(_ref, _excluded);
  var prefixCls = getPrefixCls("select");
  placeholder = label ? label : placeholder;
  var _useMergedState = useMergedState(props.defaultValue, {
      value: props.value
    }),
    _useMergedState2 = _slicedToArray(_useMergedState, 2),
    value = _useMergedState2[0],
    setValue = _useMergedState2[1];
  var hasValue = value !== undefined && value !== null;
  useEffect(function () {
    setValue(value);
  }, [value]);
  var handleChange = function handleChange(value, options) {
    setValue(value);
    onChange === null || onChange === void 0 ? void 0 : onChange(value, options);
  };
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    focused = _useState2[0],
    setFocused = _useState2[1];
  var handleFocus = useCallback(function (e) {
    setFocused(true);
    onFocus === null || onFocus === void 0 ? void 0 : onFocus(e);
  }, [onFocus]);
  var handleBlur = useCallback(function (e) {
    setFocused(false);
    onBlur === null || onBlur === void 0 ? void 0 : onBlur(e);
  }, [onBlur]);
  var _useMergedState3 = useMergedState(pSearchValue, {
      value: pSearchValue
    }),
    _useMergedState4 = _slicedToArray(_useMergedState3, 2),
    searchValue = _useMergedState4[0],
    setSearchValue = _useMergedState4[1];
  useEffect(function () {
    if (pSearchValue !== searchValue) {
      setSearchValue(pSearchValue);
    }
  }, [pSearchValue]);
  var inputRef = useRef(null);
  var handleDropdownVisibleChange = useCallback(function (open) {
    onDropdownVisibleChange === null || onDropdownVisibleChange === void 0 ? void 0 : onDropdownVisibleChange(open);
    if (open) {
      setTimeout(function () {
        var _inputRef$current;
        (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 ? void 0 : _inputRef$current.focus();
      }, 20);
    }
  }, [onDropdownVisibleChange]);
  var handleDropdownRender = useEvent(function (menu) {
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [showSearch && /*#__PURE__*/_jsx("div", {
        className: classNames("".concat(prefixCls, "-search")),
        children: /*#__PURE__*/_jsx(Input, {
          ref: inputRef,
          prefix: /*#__PURE__*/_jsx(IconSearch16pxRegular, {
            size: 16
          }),
          placeholder: placeholder,
          className: "".concat(prefixCls, "-search-input"),
          value: searchValue,
          allowClear: true,
          onChange: function onChange(e) {
            setSearchValue(e.target.value);
            onSearch === null || onSearch === void 0 ? void 0 : onSearch(e.target.value);
          }
        })
      }), (dropdownRender === null || dropdownRender === void 0 ? void 0 : dropdownRender(menu)) || menu]
    });
  });
  return /*#__PURE__*/_jsxs("div", {
    style: style,
    className: cns("".concat(prefixCls, "-wrap"), className, (_cns = {}, _defineProperty(_cns, "".concat(prefixCls, "-wrap-status-error"), status === "error"), _defineProperty(_cns, "".concat(prefixCls, "-wrap-disabled"), disabled), _defineProperty(_cns, "".concat(prefixCls, "-wrap-has-value"), hasValue), _defineProperty(_cns, "".concat(prefixCls, "-wrap-focused"), focused), _defineProperty(_cns, "".concat(prefixCls, "-wrap-lg"), size === "large"), _defineProperty(_cns, "".concat(prefixCls, "-wrap-sm"), size === "small"), _defineProperty(_cns, "".concat(prefixCls, "-wrap-label-left"), labelMode === "left"), _defineProperty(_cns, "".concat(prefixCls, "-wrap-label-top"), labelMode === "top"), _defineProperty(_cns, "".concat(prefixCls, "-wrap-show-search"), showSearch), _defineProperty(_cns, "".concat(prefixCls, "-wrap-borderless"), !bordered), _cns)),
    children: [/*#__PURE__*/_jsxs("div", {
      className: cns("".concat(prefixCls, "-inside-wrap"), _defineProperty({}, "".concat(prefixCls, "-inside-wrap-has-value"), hasValue)),
      children: [/*#__PURE__*/_jsx(ASelect, _objectSpread(_objectSpread({
        prefixCls: prefixCls,
        value: value,
        onChange: handleChange,
        onDropdownVisibleChange: handleDropdownVisibleChange,
        placeholder: !label ? placeholder : undefined,
        maxTagCount: maxTagCount,
        maxTagPlaceholder: maxTagPlaceholder
      }, props), {}, {
        showSearch: showSearch,
        searchValue: searchValue,
        onSearch: showSearch ? function (value) {
          setSearchValue(value);
          onSearch === null || onSearch === void 0 ? void 0 : onSearch(value);
        } : undefined,
        dropdownRender: handleDropdownRender,
        onBlur: handleBlur,
        onFocus: handleFocus,
        disabled: disabled,
        size: size,
        ref: ref
      })), !!label && /*#__PURE__*/_jsx("label", {
        className: "".concat(prefixCls, "-label"),
        children: placeholder
      })]
    }), /*#__PURE__*/_jsx("fieldset", {
      className: "".concat(prefixCls, "-outline"),
      children: /*#__PURE__*/_jsx("legend", {
        className: cns("".concat(prefixCls, "-label-bg"), _defineProperty({}, "".concat(prefixCls, "-label-bg-none"), !label)),
        children: /*#__PURE__*/_jsx("span", {
          children: placeholder
        })
      })
    })]
  });
});
Select.Option = ASelect.Option;
Select.OptGroup = ASelect.OptGroup;